import { Alert, AlertTitle, Box, Link } from '@mui/material';

import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { useLocale } from '@shared/hooks/locale';

import { dashboardCenterSx } from './constants';

export const SubscriptionAlert = () => {
  const { t } = useLocale();
  const { me } = useAppData();

  if (me?.subscriptions?.[0]?.status !== 'past_due') {
    return null;
  }

  return (
    <Box
      sx={[
        {
          width: 1,
          pt: 3,
        },
        ...(Array.isArray(dashboardCenterSx)
          ? dashboardCenterSx
          : [dashboardCenterSx]),
      ]}
    >
      <Alert severity="error">
        <AlertTitle>
          {t('There has been a problem charging your credit card.')}
        </AlertTitle>
        {t(
          'Please update your payment method to keep your subscription active.',
        )}{' '}
        <Link
          href={
            me?.subscriptions?.[0]?.customer
              ? `https://dashboard.stripe.com/customers/${me.subscriptions[0].customer}`
              : '#'
          }
          target="_blank"
          rel="noopener noreferrer"
          onClick={e => {
            if (me?.subscriptions?.[0]?.customer == null) {
              e.preventDefault();
              console.error('No customer ID available');
            }
          }}
          sx={{ fontWeight: 600, color: 'primary.main' }}
        >
          {t('Update now')} &gt;
        </Link>
      </Alert>
    </Box>
  );
};

export default SubscriptionAlert;
